'use strict';

let updateRouteBasedContentFiltersByImportSessionIdParam = function (routeBasedContentFilters, importSessionId) {

    // Start of with empty lists before an import session is selected
    routeBasedContentFilters.ImportSessionManyManyFile_import_session_id = importSessionId;
    routeBasedContentFilters.InboxQueryResponse_import_session_id = importSessionId;
    routeBasedContentFilters.ClerkTransactionRow_Interpretation_Clue_InputResult_import_session_id = importSessionId;
    routeBasedContentFilters.ClerkInvoice_Interpretation_Clue_InputResult_import_session_id = importSessionId;
    routeBasedContentFilters.ClerkInvoiceRow_Interpretation_Clue_InputResult_import_session_id = importSessionId;
    //routeBasedContentFilters.ClerkInvoiceItem_Interpretation_Clue_InputResult_import_session_id = importSessionId;
    // NOTE: ClerkAccount filter is disabled to be able to assign clerk input result metadata's clerk accounts TODO: Make this work anyway
    // routeBasedContentFilters.ClerkAccount_ClerkTransactionRow_Interpretation_Clue_InputResult_import_session_id = importSessionId;
    // The following workaround filter is tagged as left join to indicate that it does not actually filter on clerk accounts, but on their related ctr queries
    routeBasedContentFilters.ClerkAccount_LeftJoin_ClerkTransactionRow_Interpretation_Clue_InputResult_import_session_id = importSessionId;
    routeBasedContentFilters.ClerkAccountBalance_Interpretation_Clue_InputResult_import_session_id = importSessionId;
    routeBasedContentFilters.Interpretation_Clue_InputResult_import_session_id = importSessionId;
    routeBasedContentFilters.Clue_InputResult_import_session_id = importSessionId;
    routeBasedContentFilters.InputResult_import_session_id = importSessionId;
    routeBasedContentFilters.ClerkInputResultMetadata_InputResult_import_session_id = importSessionId;
    routeBasedContentFilters.DenormalizedNeamtimeInvoicedTime_Interpretation_Clue_InputResult_import_session_id = importSessionId;
    routeBasedContentFilters.NeamtimeTimeSpentInterpretation_Interpretation_Clue_InputResult_import_session_id = importSessionId;
    routeBasedContentFilters.NeamtimeSignificantTimeInterpretation_NeamtimeTimeSpentInterpretation_Interpretation_Clue_InputResult_import_session_id = importSessionId;
    routeBasedContentFilters.NeamtimeInvoicedTime_NeamtimeSignificantTimeInterpretation_NeamtimeTimeSpentInterpretation_Interpretation_Clue_InputResult_import_session_id = importSessionId;
    routeBasedContentFilters.NeamtimeInputResultMetadata_InputResult_import_session_id = importSessionId;

    // General routebased content filters that are not dependent on import session id param
    routeBasedContentFilters.ImportSessionManyManyFile_not_yet_import_processed = 1;
    routeBasedContentFilters.InputResult_not_yet_import_processed = 1;
    routeBasedContentFilters.ClerkInputResultMetadata_InputResult_not_yet_import_processed = 1;
    routeBasedContentFilters.NeamtimeInputResultMetadata_InputResult_not_yet_import_processed = 1;
    routeBasedContentFilters.Interpretation_has_location = 1;
    routeBasedContentFilters.ClerkSupportingDocument_order = 'ClerkSupportingDocument.created DESC, ClerkSupportingDocument.id DESC';

};

let loadImportSessionByImportSessionIdParam = function ($q, importSession, importSessionId, clerkLedgerDeliverable, importSessions) {

    if (importSessionId) {
        if (importSessionId === 'current') {
            // using 'current' as the id reference will use the relevant import session id
            // that either picks up from the last session or points to a new import session if no
            // previous import session was started
            importSessions.$activate();
            let defer = $q.defer();
            importSessions.$promise.then(function () {
                importSession.$activate();
                let promise = importSession.load(importSessions.$metadata.currentImportSessionId);
                promise.then(function (loadedImportSession) {
                    defer.resolve(loadedImportSession);
                });
            });
            return defer.promise;
        } else if (importSessionId === 'by-todo-list-item') {
            // using 'by-todo-list-item' as the id reference uses the automatically created
            // import session related to the current ledger deliverable
            clerkLedgerDeliverable.$activate();
            let defer = $q.defer();
            clerkLedgerDeliverable.$promise.then(function () {
                importSession.$activate();
                let promise = importSession.load(clerkLedgerDeliverable.attributes.importSession.id);
                promise.then(function (loadedImportSession) {
                    defer.resolve(loadedImportSession);
                });
            });
            return defer.promise;
        } else {
            importSession.$activate();
            return importSession.load(importSessionId);
        }
    } else {
        return importSession.load(null);
    }

};

let routes = function ($stateProvider, baseState) {

    // TODO: Wrap below in a modal route tree

    $stateProvider

        .state('' + baseState + '.import', {
            abstract: true,
            url: "/import",
            template: "<ui-view/>",
            controller: 'ImportScopeController',
        })

        .state('' + baseState + '.import.overview', {
            url: "/overview",
            template: require("./import.overview.html"),
            data: {pageTitle: 'Import'}
        })

        .state('' + baseState + '.import.optionally-by-import-session', {
            abstract: true,
            url: "/:activeImportSessionId?importProcessingStep?",
            params: {
                activeImportSessionId: {value: 'all', dynamic: true},
                importProcessingStep: {value: '1', dynamic: true}
            },
            resolve: {
                setRouteBasedVisibilitySettingsLevel1: /*@ngInject*/ function (setRouteBasedVisibilitySettingsLevel0, routeBasedVisibilitySettings) {
                    routeBasedVisibilitySettings.SuggestedAction_columns_by_step = 'simple';

                    // TODO: Different depending on import-processing-step (1,2,3,4,5 etc - for instance input content type step is different from checking import process status counts at the end etc)
                    routeBasedVisibilitySettings.InputResult_columns_by_step = 'simple';

                    routeBasedVisibilitySettings.ImportSession_columns_by_step = 'simple';
                },
                setRouteBasedContentFiltersLevel1: /*@ngInject*/ function (setRouteBasedContentFiltersLevel1A, routeBasedContentFilters, $stateParams, $q, importSession, clerkLedgerDeliverable, importSessions) {
                    let importSessionId = $stateParams.activeImportSessionId === 'all' ? null : $stateParams.activeImportSessionId;
                    loadImportSessionByImportSessionIdParam($q, importSession, importSessionId, clerkLedgerDeliverable, importSessions).then(
                        function (loadedImportSession) {
                            let importSessionId = loadedImportSession.$id;
                            updateRouteBasedContentFiltersByImportSessionIdParam(routeBasedContentFilters, importSessionId);
                        }
                    );
                },
                currentImportSession: /*@ngInject*/ function (dataEnvironmentParam, $stateParams, $q, importSession, clerkLedgerDeliverable, importSessions) {
                    console.log('optionally-by-import-session - currentImportSession', $stateParams);
                    let importSessionId = $stateParams.activeImportSessionId === 'all' ? null : $stateParams.activeImportSessionId;
                    return loadImportSessionByImportSessionIdParam($q, importSession, importSessionId, clerkLedgerDeliverable, importSessions);
                },
            },
            views: {
                '': {
                    template: '<ui-view id="optionally-by-import-session-ui-view"/>',
                    controller: /*@ngInject*/ function (routeBasedContentFilters, $scope, $q, importSession, clerkLedgerDeliverable, importSessions) {

                        this.uiOnParamsChanged = function (changedParams, $transition$) {
                            console.log('optionally-by-import-session - routes.uiOnParamsChanged', changedParams, $transition$);
                            if (changedParams.activeImportSessionId) {
                                let importSessionId = changedParams.activeImportSessionId === 'all' ? null : changedParams.activeImportSessionId;
                                loadImportSessionByImportSessionIdParam($q, importSession, importSessionId, clerkLedgerDeliverable, importSessions).then(
                                    function (loadedImportSession) {
                                        let importSessionId = loadedImportSession.$id;
                                        updateRouteBasedContentFiltersByImportSessionIdParam(routeBasedContentFilters, importSessionId);
                                    }
                                );
                            }
                        };
                    },
                },
            },
            onExit: /*@ngInject*/ function (routeBasedContentFilters, $q, importSession) {
                let importSessionId = null;
                updateRouteBasedContentFiltersByImportSessionIdParam(routeBasedContentFilters, importSessionId);
                loadImportSessionByImportSessionIdParam($q, importSession, importSessionId);
            },
            data: {
                showSideMenu: true
            }
        });

    let views = {};
    views[''] = {
        template: require("./import.financial-data.html"),
        controller: 'FinancialDataImportController',
    };
    views['currentImportSession@' + baseState + '.import.optionally-by-import-session.financial-data'] = {
        template: require("./current-import-session.html"),
    };
    views['currentImportSessionImportApproach@' + baseState + '.import.optionally-by-import-session.financial-data'] = {
        template: require("./current-import-session.files-to-input-results.html"),
    };

    $stateProvider

        .state('' + baseState + '.import.optionally-by-import-session.financial-data', {
            url: "/financial-data",
            views: views,
            resolve: {
                setRouteBasedVisibilitySettingsLevel2: /*@ngInject*/ function (setRouteBasedVisibilitySettingsLevel1, routeBasedVisibilitySettings, $stateParams) {
                    routeBasedVisibilitySettings.ClerkInputResultMetadata_columns_by_step = 'financial-data-import';
                },
                setRouteBasedContentFiltersLevel2: /*@ngInject*/ function (setRouteBasedContentFiltersLevel1, routeBasedContentFilters, $stateParams) {
                    routeBasedContentFilters.ClerkAccount_relevant_for_financial_data_import = 1;
                    // TODO: Filter to only show iss, irs and cirms that are relevant to financial-data-import + unknowns
                },
            },
            data: {pageTitle: 'Inspect'}
        })

    ;

    views = {};
    views[''] = {
        template: require("./import.invoice-data.html"),
        controller: 'FinancialDataImportController',
    };
    views['currentImportSession@' + baseState + '.import.optionally-by-import-session.invoice-data'] = {
        template: require("./current-import-session.html"),
    };
    views['currentImportSessionImportApproach@' + baseState + '.import.optionally-by-import-session.invoice-data'] = {
        template: require("./current-import-session.files-to-input-results.html"),
    };

    $stateProvider

        .state('' + baseState + '.import.optionally-by-import-session.invoice-data', {
            url: "/invoice-data",
            views: views,
            resolve: {
                setRouteBasedVisibilitySettingsLevel2: /*@ngInject*/ function (setRouteBasedVisibilitySettingsLevel1, routeBasedVisibilitySettings, $stateParams) {
                    routeBasedVisibilitySettings.ClerkInputResultMetadata_columns_by_step = 'invoice-data-import';
                },
                setRouteBasedContentFiltersLevel2: /*@ngInject*/ function (setRouteBasedContentFiltersLevel1, routeBasedContentFilters, $stateParams) {
                    routeBasedContentFilters.ClerkAccount_relevant_for_financial_data_import = 1;
                    // TODO: Filter to only show iss, irs and cirms that are relevant to invoice-data-import + unknowns
                },
            },
            data: {pageTitle: 'Inspect'}
        })

    ;

    views = {};
    views[''] = {
        template: require("./import.accounting-work.html"),
        controller: 'AccountingWorkImportController',
    };
    views['currentImportSession@' + baseState + '.import.optionally-by-import-session.accounting-work'] = {
        template: require("./current-import-session.html"),
    };
    views['currentImportSessionImportApproach@' + baseState + '.import.optionally-by-import-session.accounting-work'] = {
        template: require("./current-import-session.files-to-input-results.html"),
    };

    $stateProvider

        .state('' + baseState + '.import.optionally-by-import-session.accounting-work', {
            url: "/accounting-work",
            views: views,
            resolve: {
                setRouteBasedContentFiltersLevel2: /*@ngInject*/ function (setRouteBasedContentFiltersLevel1, routeBasedContentFilters, $stateParams) {
                    routeBasedContentFilters.ClerkAccount_relevant_for_financial_data_import = 1;
                },
            },
            data: {pageTitle: 'Inspect'}
        })

    ;

    views = {};
    views[''] = {
        template: require("./import.time-spending-logs.html"),
    };
    views['currentImportSession@' + baseState + '.import.optionally-by-import-session.time-spending-logs'] = {
        template: require("./current-import-session.html"),
    };
    views['currentImportSessionImportApproach@' + baseState + '.import.optionally-by-import-session.time-spending-logs'] = {
        template: require("./current-import-session.text-to-input-results.html"),
    };

    $stateProvider

        .state('' + baseState + '.import.optionally-by-import-session.time-spending-logs', {
            url: "/time-spending-logs",
            views: views,
            resolve: {},
            data: {pageTitle: 'Inspect'}
        })

    ;

    views = {};
    views[''] = {
        template: require("./import.images.html"),
    };
    views['currentImportSession@' + baseState + '.import.optionally-by-import-session.images'] = {
        template: require("./current-import-session.html"),
    };
    views['currentImportSessionImportApproach@' + baseState + '.import.optionally-by-import-session.images'] = {
        template: require("./current-import-session.files-to-input-results.html"),
    };

    $stateProvider

        .state('' + baseState + '.import.optionally-by-import-session.images', {
            url: "/images",
            views: views,
            resolve: {},
            data: {pageTitle: 'Inspect'}
        })

    ;

    views = {};
    views[''] = {
        template: require("./import.mailbox.html"),
        controller: 'FinancialDataMailboxAndLocationDataImportController',
    };
    views['currentImportSession@' + baseState + '.import.optionally-by-import-session.mailbox'] = {
        template: require("./current-import-session.html"),
    };
    views['currentImportSessionImportApproach@' + baseState + '.import.optionally-by-import-session.mailbox'] = {
        template: require("./current-import-session.mailbox-to-input-results.html"),
    };

    $stateProvider

        .state('' + baseState + '.import.optionally-by-import-session.mailbox', {
            url: "/mailbox",
            views: views,
            resolve: {},
            data: {pageTitle: 'Inspect'}
        })

    ;

    views = {};
    views[''] = {
        template: require("./import.version-control-system.html"),
    };
    views['currentImportSession@' + baseState + '.import.optionally-by-import-session.version-control-system'] = {
        template: require("./current-import-session.html"),
    };
    views['currentImportSessionImportApproach@' + baseState + '.import.optionally-by-import-session.version-control-system'] = {
        template: require("./current-import-session.version-control-system-to-input-results.html"),
    };

    $stateProvider

        .state('' + baseState + '.import.optionally-by-import-session.version-control-system', {
            url: "/version-control-system",
            views: views,
            resolve: {},
            data: {pageTitle: 'Inspect'}
        })

    ;

    views = {};
    views[''] = {
        template: require("./import.location-data.html"),
    };
    views['currentImportSession@' + baseState + '.import.optionally-by-import-session.location-data'] = {
        template: require("./current-import-session.html"),
    };
    views['currentImportSessionImportApproach@' + baseState + '.import.optionally-by-import-session.location-data'] = {
        template: require("./current-import-session.files-to-input-results.html"),
    };

    $stateProvider

        .state('' + baseState + '.import.optionally-by-import-session.location-data', {
            url: "/location-data",
            views: views,
            resolve: {},
            data: {pageTitle: 'Inspect'}
        })

    /*
     .state('' + baseState + '.import.optionally-by-import-session.from-software-or-service', {
     url: "/software",
     template: require("./import.from-software-or-service.html"),
     resolve: {},
     data: {pageTitle: 'Inspect'}
     })
     */

    ;

    // TODO: Ability to list and inspect imported data under import-session-filter here via subsections

};

let loadRoutesLazily = function ($stateProvider, baseState) {

    let lazyStateProvider = {
        states: [],
        state: function (name, stateConfig) {
            let state = angular.merge({name: name}, stateConfig);
            this.states.push(state);
            return this;
        }
    };
    routes(lazyStateProvider, baseState);
    $stateProvider.state(baseState + '.import.**', {
        url: "/import",
        lazyLoad: function ($transition$, ParentService) {
            return lazyStateProvider;
        },
    });

};

export default {
    routes: routes,
    loadRoutesLazily: loadRoutesLazily,
};



// WEBPACK FOOTER //
// .-dna/app/subsections/grant-and-import/grant-and-import.routing.js